import { BtnPrimary, BtnSecondary } from '@components/buttons';
import { BaseDialog, showGlobal } from '@components/dialog';
import { IcoCheckCircle } from '@components/icons';
import { AppRouter } from '@components/router';
import { useEffect } from 'preact/hooks';
import { once } from 'shared/utils';

export function useNagDialog({ router, isPublished }: { isPublished: boolean; router: AppRouter }) {
  useEffect(() => {
    if (isPublished) {
      return;
    }
    const handler = once(() => {
      showGlobal(({ resolve }) => (
        <BaseDialog onClose={() => resolve(undefined)} contentWidth>
          <div class="flex flex-col gap-6 p-12 text-base font-medium max-w-lg">
            <header class="text-center flex flex-col gap-2">
              <span class="mb-4">
                <span class="inline-flex justify-center items-center rounded-full bg-gradient-to-br from-indigo-600 to-violet-500 text-3xl size-16">
                  🚀
                </span>
              </span>
              <h1 class="text-2xl font-semibold text-gray-900">
                You're One Click Away from a Booking Page Worth Sharing
              </h1>
              <p class="text-gray-500 font-medium leading-normal">
                Your new page looks amazing. Publishing it takes 30 seconds and gets you live and
                ready for new prospects. discoverable instantly.
              </p>
            </header>
            <ul>
              <li class="flex items-center gap-2">
                <IcoCheckCircle class="text-green-500 size-6" /> Get a professional URL
              </li>
              <li class="flex items-center gap-2">
                <IcoCheckCircle class="text-green-500 size-6" /> Start booking prospects right away
              </li>
              <li class="flex items-center gap-2">
                <IcoCheckCircle class="text-green-500 size-6" /> Share your page across social media
              </li>
            </ul>
            <footer class="flex flex-col gap-4">
              <nav class="grid grid-cols-2 gap-4">
                <BtnPrimary
                  onClick={() => {
                    router.goto('/calendar/signup');
                    resolve(undefined);
                  }}
                  class="rounded-lg bg-gradient-to-br from-indigo-600 to-violet-500 p-4 hover:from-indigo-700 text-base leading-normal"
                >
                  Publish My Page Now
                </BtnPrimary>
                <BtnSecondary class="rounded-lg text-base" onClick={resolve}>
                  Save for Later
                </BtnSecondary>
              </nav>
              <aside class="text-sm text-center">
                <p class="text-gray-500">Takes 30 seconds • No credit card required</p>
                <p>Join the thousands of coaches who use our products.</p>
              </aside>
            </footer>
          </div>
        </BaseDialog>
      ));
    });
    const onMouseLeave = (e: MouseEvent) => {
      if (e.layerY < 16) {
        handler();
      }
    };
    document.documentElement.addEventListener('mouseleave', onMouseLeave);
    return () => document.documentElement.removeEventListener('mouseleave', onMouseLeave);
  }, []);
}
